<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="proId"
      :col="3"
      :item-names="['s1','s2']"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="s1" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
      </a-form-item>
      <!--      <a-form-item slot="s2" label="商品ID" v-bind="searchItemLayout">-->
      <!--        <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>-->
      <!--      </a-form-item>-->
      <a-form-item slot="s2" label="订单类型" v-bind="searchItemLayout">
        <a-select v-model="queryParams.proCatalog" style="width: 100%">
          <a-select-option :value="1">旅游门票</a-select-option>
          <a-select-option :value="2">酒店</a-select-option>
          <a-select-option :value="8">抢购</a-select-option>
          <a-select-option :value="83">预约</a-select-option>
        </a-select>
      </a-form-item>
      <template slot="index" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <template slot="proType" slot-scope="rowItem">{{ rowItem.record.proCatalogId | getAllProductTypeName }}</template>
      <template slot="proStatus" slot-scope="rowItem">{{ rowItem.record.proStatus == 1 ? '上架' : '' }}</template>
      <div slot="action" slot-scope="rowItem">
        <a @click="createCodeEvent(rowItem.record)">手工下单</a>
      </div>
    </search-page-view>
    <!--新增酒店手工下单-->
    <HotelSubmit
      :hotelVisible="hotelVisible"
      ref="child"
      :hotelData="hotelData"
      @choseDate="closeDilog"
    >
    </HotelSubmit>
    <!--旅游门票手工下单下单-->
    <TicketSubmit
      :ticketVisible="ticketVisible"
      ref="child2"
      :hotelData="hotelData"
      @choseDate="closeDilog"
    >
    </TicketSubmit>
    <!--抢购手工下单下单-->
    <PresaleSubmit
      :presaleVisible="presaleVisible"
      ref="child3"
      :hotelData="hotelData"
      @choseDate="closeDilog"
    >
    </PresaleSubmit>
    <!--预约手工下单下单-->
    <AppointmentSubmit
      :appointmentVisible="appointmentVisible"
      ref="child4"
      :hotelData="hotelData"
      @choseDate="closeDilog"
    >
    </AppointmentSubmit>

  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import HotelSubmit from './components/HotelSubmit'
import TicketSubmit from './components/TicketSubmit'
import PresaleSubmit from './components/PresaleSubmit'
import AppointmentSubmit from './components/AppointmentSubmit'
import { claLoad, select, getDateData } from './chooseDateTime'

export default {
  name: 'CommondityList',
  mixins: [searchForm, formMixin],
  components: { HotelSubmit, TicketSubmit, PresaleSubmit, AppointmentSubmit },
  data() {
    return {
      queryParams: {
        proCatalog: 1
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '400px'
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品类型',
          dataIndex: 'proType',
          scopedSlots: { customRender: 'proType' }
        },
        {
          title: '上架状态',
          dataIndex: 'proStatus',
          scopedSlots: { customRender: 'proStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      hotelVisible: false,
      ticketVisible: false,
      presaleVisible: false,
      appointmentVisible: false,
      hotelData: {}
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
  },
  mounted() {

  },
  methods: {
    // 获取列表数据接口
    getListPromise(params) {
      return this.getHttpServices().getProService().post('resource/pro/get/itemPro', params)
    },
    createCodeEvent(type) {  //2酒店 1门票 8抢购 83预约
      this.hotelData = type
      if (type.proCatalogId == 2) {
        this.hotelVisible = true
        this.$refs.child.getHotelPanList(type.proId)
      } else if (type.proCatalogId == 1) {
        this.ticketVisible = true
        this.$refs.child2.getHotelPanList(type)
      } else if (type.proCatalogId == 8) {
        this.presaleVisible = true
        this.$refs.child3.getHotelPanList(type)
      } else {
        this.appointmentVisible = true
        this.$refs.child4.getHotelPanList(type)
      }
    },
    closeDilog() {
      this.hotelVisible = false
      this.ticketVisible = false
      this.presaleVisible = false
      this.appointmentVisible = false
    }
  }
}
</script>
<style lang="less">
.commondity-list {
  .ant-fullcalendar table {
    height: 100px;
    border: 0;
    margin: 0;
    border-collapse: collapse;
    border-spacing: 0;

    tr {
      td {
        box-sizing: border-box;
        margin: 0px;
        padding: 0;
        border: 1px #d1d1d1 solid;
      }
    }
  }

  .backColor {
    position: absolute;
    background-color: #ffebcf;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .bgText {
    display: block;
    margin: 40px 0 0 20px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 100px;
    background-color: #fff;
    margin: 0;
    border-top: none;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date .ant-fullcalendar-value {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
  }
}

.commondity-list-style {
  .ant-fullcalendar-value {
    color: #fff;
  }
}

.ant-modal-body {
  min-height: 400px;
}

</style>
